(() => {
  const descriptionSelector = [
    'product-info .product__block--description.rte',
    'product-info .product__block--rich-text.rte',
  ].join(', ');
  const initializedAttribute = 'data-h2-accordion-ready';

  const iconMarkup = `
    <svg
      xmlns="http://www.w3.org/2000/svg"
      class="icon icon-plus-toggle icon--medium icon--thick"
      viewBox="0 0 20 20"
      fill="none"
      aria-hidden="true"
      focusable="false"
    >
      <path class="horizontal" d="M3.125 10H16.875" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
      <path class="vertical" d="M10 3.125V16.875" stroke="currentColor" stroke-width="1.5" stroke-linecap="round" stroke-linejoin="round"/>
    </svg>
  `;

  function createAccordionHeading(heading, headingSizeClass) {
    const normalizedHeading = document.createElement('h2');
    normalizedHeading.className = `product-description-accordion__heading inline-richtext ${headingSizeClass}`;
    normalizedHeading.textContent = heading.textContent.trim();

    return normalizedHeading;
  }

  function hasMeaningfulContent(nodes) {
    return nodes.some((node) => {
      if (node.nodeType === Node.TEXT_NODE) {
        return node.textContent.trim().length > 0;
      }

      if (node.nodeType !== Node.ELEMENT_NODE) {
        return false;
      }

      return node.textContent.trim().length > 0 || node.matches('img, iframe, video, table, ul, ol, blockquote');
    });
  }

  function buildAccordionItem(heading, contentNodes) {
    const productInfo = heading.closest('product-info');
    const headingSizeClass = productInfo?.dataset.descriptionAccordionHeadingSize || 'h4';
    const normalizedHeading = createAccordionHeading(heading, headingSizeClass);
    const details = document.createElement('details');
    const summary = document.createElement('summary');
    const headingWrap = document.createElement('div');
    const content = document.createElement('div');

    details.className = 'accordion-details product-description-accordion__item';
    details.setAttribute('aria-expanded', 'false');

    summary.className = 'accordion-details__summary product-description-accordion__summary flex items-center justify-between';
    headingWrap.className = 'flex items-center gap-2';

    content.className = 'accordion-details__content product-description-accordion__content';

    headingWrap.appendChild(normalizedHeading);
    summary.appendChild(headingWrap);
    summary.insertAdjacentHTML('beforeend', iconMarkup);
    contentNodes.forEach((node) => content.appendChild(node));

    details.appendChild(summary);
    details.appendChild(content);
    details.addEventListener('toggle', () => {
      details.setAttribute('aria-expanded', details.open ? 'true' : 'false');
    });

    return details;
  }

  function appendHeadingGroup(fragment, heading, contentNodes) {
    if (!heading) return;

    if (!hasMeaningfulContent(contentNodes)) {
      fragment.appendChild(heading);
      contentNodes.forEach((node) => fragment.appendChild(node));
      return;
    }

    fragment.appendChild(buildAccordionItem(heading, contentNodes));
  }

  function getAccordionTarget(description) {
    if (Array.from(description.children).some((child) => child.tagName === 'H2')) {
      return description;
    }

    return Array.from(description.children).find((child) =>
      Array.from(child.children).some((grandchild) => grandchild.tagName === 'H2')
    );
  }

  function initDescriptionAccordion(description) {
    if (
      description.hasAttribute(initializedAttribute) ||
      description.closest('.product-description-accordion__content')
    ) {
      return;
    }

    const target = getAccordionTarget(description);
    if (!target) {
      description.setAttribute(initializedAttribute, 'true');
      return;
    }

    const nodes = Array.from(target.childNodes);
    const fragment = document.createDocumentFragment();
    let activeHeading = null;
    let activeContent = [];

    nodes.forEach((node) => {
      if (node.nodeType === Node.ELEMENT_NODE && node.tagName === 'H2') {
        appendHeadingGroup(fragment, activeHeading, activeContent);
        activeHeading = node;
        activeContent = [];
        return;
      }

      if (activeHeading) {
        activeContent.push(node);
      } else {
        fragment.appendChild(node);
      }
    });

    appendHeadingGroup(fragment, activeHeading, activeContent);

    target.classList.add('product-description-accordion');
    target.replaceChildren(fragment);

    description.setAttribute(initializedAttribute, 'true');
  }

  function initProductDescriptionAccordions(root = document) {
    root.querySelectorAll(descriptionSelector).forEach(initDescriptionAccordion);
  }

  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', () => initProductDescriptionAccordions());
  } else {
    initProductDescriptionAccordions();
  }

  window.addEventListener('load', () => initProductDescriptionAccordions());
  document.addEventListener('shopify:section:load', (event) => initProductDescriptionAccordions(event.target));
})();
